// Copyright (C) 2024 by Posit Software, PBC.

const pluralize = (count, singular, plural) => (
  count === 1 ? singular : plural
);

export default pluralize;
